import $ from 'jquery';
import 'inputmask/dist/jquery.inputmask.js';

export function initFormValidation(): void {
  $('.js-phone-mask').inputmask('+7 999 999-99-99');

  const doc = $(document);

  function setError($input: JQuery<HTMLElement>, message?: string): void {
    $input.addClass('error');

    const $errorText = $input.next('.error-message');

    if (!$errorText.length) return;

    if (!$errorText.data('default-text')) {
      $errorText.data('default-text', $errorText.text());
    }

    if (message) {
      $errorText.text(message);
    }
  }

  function clearError($input: JQuery<HTMLElement>): void {
    $input.removeClass('error');

    const $errorText = $input.next('.error-message');

    if (!$errorText.length) return;

    const defaultText = $errorText.data('default-text') as string | undefined;
    if (defaultText) {
      $errorText.text(defaultText);
    }
  }

  function getFieldStringValue($input: JQuery<HTMLElement>): string {
    const v = $input.val();
    if (v == null) return '';
    if (Array.isArray(v)) return v.join('');
    return String(v);
  }

  function getNativeType(el: HTMLElement): string {
    if (el instanceof HTMLInputElement) return el.type;
    if (el instanceof HTMLSelectElement) return el.type;
    return 'textarea';
  }

  // Валидация файлов
  doc.on('change', '.js-file', function (this: HTMLInputElement) {
    const file = this.files?.[0];

    if (!file) {
      $(this).removeClass('error');
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/png'] as const;

    if (!allowedTypes.includes(file.type as (typeof allowedTypes)[number])) {
      $(this).addClass('error');
      this.value = '';
    } else {
      $(this).removeClass('error');
    }
  });

  // Отправка формы
  doc.on('submit', '.js-form', function (this: HTMLFormElement, e: JQuery.Event) {
    let errors = 0;
    const $form = $(this);
    const $requireds = $form.find('.required');

    $requireds.each(function (this: HTMLElement) {
      clearError($(this));
    });

    $requireds.each(function (this: HTMLElement) {
      const $input = $(this);
      const el = this;
      const type = getNativeType(el);
      const val = getFieldStringValue($input);

      if (el instanceof HTMLInputElement && type === 'checkbox' && $input.hasClass('required-checkbox')) {
        if (!el.checked) {
          $input.addClass('error');
          errors += 1;
        }
        return;
      }

      if (el instanceof HTMLInputElement && type === 'radio' && $input.hasClass('required-radio')) {
        const { name } = el;
        const isRadioChecked = $form.find(`input[name="${name}"]:checked`).length > 0;
        if (!isRadioChecked) {
          $form.find(`input[name="${name}"]`).addClass('error');
          errors += 1;
        }
        return;
      }

      if (val.length === 0) {
        $input.addClass('error');
        errors += 1;
        return;
      }

      if ($input.hasClass('required-phone')) {
        const phone = val.replace(/\D+/g, '');
        if (phone.length < 11) {
          setError($input, 'Некорректный формат телефона');
          $input.addClass('error');
          errors += 1;
          return;
        }
      }

      if ($input.hasClass('required-mail')) {
        const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailReg.test(val)) {
          setError($input, 'Некорректный формат e-mail');
          $input.addClass('error');
          errors += 1;
          return;
        }
      }

      if ($input.hasClass('required-evaluation') && !/^[1-5]$/.test(val)) {
        $input.addClass('error');
        errors += 1;
      }
    });

    if (errors > 0) {
      e.preventDefault();
    } else {
      $('.modal').removeClass('show');
      $('#send-reaction').addClass('show');
    }
  });

  doc.on('change', '.required-checkbox', function (this: HTMLInputElement) {
    if (this.checked) {
      $(this).removeClass('error');
    }
  });

  doc.on('change', '.required-radio', function (this: HTMLInputElement) {
    const { name } = this;
    $(`input[name="${name}"]`).removeClass('error');
  });

  doc.on('focus', '.required', function (this: HTMLElement) {
    $(this).removeClass('error');
  });

  doc.on('input', '.required', function (this: HTMLElement) {
    $(this).removeClass('error');
  });

  doc.on('change', 'select.required', function (this: HTMLElement) {
    $(this).removeClass('error');
  });
}
